<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     最近更新模型
  +---------------------------------------------------------------------------------------
-->

<template>
  <div>
    <div class="flex align-items-center">
      <div class="bd front-line">最近更新模型</div>
    </div>

    <el-row v-if="list.length > 0" :gutter="20">
      <el-col v-for="(item, index) in list" :key="index" :span="12" class="mt">
        <div class="bg-light radius5 flex-center" style="height: 35px;">
          <f-dev-name :dev="item" />
        </div>
      </el-col>
    </el-row>
    <div v-else class="flex-center">
      <img src="../../../assets/no-data.png" alt="" class="no-data">
    </div>
  </div>
</template>
  
  <script>
  import { devUpdateApi } from "@/api/fam/famBehaviorApi";
  export default {
    data() {
      return {
        loading: false,
        list: [],
      };
    },
  
    created() {
      this.fetchData();
    },
  
    methods: {
      fetchData() {
        this.loading = true;
        devUpdateApi({num:6}).then((res) => {
          this.loading = false;
          if (!res.errno) {
            this.list = res.data.list;
          }
        });
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .no-data {
    width: 150px;
    height: 150px;
  }
  </style>
  